import { css } from "@emotion/react";
import bgSignin from "assets/common/modal/bgAuth-signin.png";
import { theme } from "styles/theme";

export const SignupPageStyle = {
  wrapper: css`
    background: url(${bgSignin});
    background-size: 110% 110%;
    background-position: center center;
    background-color: #ccdae1;

    padding: 0 0.75rem;

    height: 100%;
  `,

  header: css`
    position: relative;
  `,

  headerLogo: css`
    text-align: center;

    img {
      width: 100%;
      height: 120px;
      object-fit: contain;
    }
  `,

  headerTextBox: {
    index: css`
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    `,

    text: css`
      h2 {
        margin: 0 0 8px;
        font-size: 14px;
        color: ${theme.colors.orange[200]};
      }
      p {
        color: ${theme.colors.orange[200]};
        margin: 0;
        font-size: 13px;
        font-weight: 300;
      }
    `,

    groupImg: css`
      display: flex;
      align-items: center;
      justify-content: center;

      margin-left: 2.5%;

      img {
        max-height: 100px;
        &:first-of-type {
          width: 52px;
          border-right: 1px solid rgb(45 118 153);
          padding-right: 10px;
        }
        &:last-of-type {
          max-width: 150px;
          padding-left: 10px;
        }
      }
    `,
  },

  form: css`
    margin-top: 20px;
    & .ant-form-item-control-input {
      & .ant-input-affix-wrapper {
        height: 34px !important;
      }
    }
    .ant-form-item {
      margin-bottom: unset !important;
    }
    svg {
      fill: ${theme.colors.orange[200]};
    }
  `,
  inputLabel: css`
    display: flex;
    align-items: center;
    gap: 3px;
    p {
      color: ${theme.colors.orange[200]};
      font-size: 16px;

      font-weight: 500;
      margin: unset !important;
    }
  `,

  groupBtn: css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;

    padding-bottom: 60px;
    button {
      width: 100%;
      height: 48px;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
      border-radius: 50px;
      color: white;
      background-color: ${theme.colors.orange[200]};
      &:last-of-type {
        background-color: #404040;
      }
    }
  `,

  checkBox: css``,

  textLabel: () => css`
    font-weight: 700;
    color: #2d7699;
    font-size: 17px;
  `,

  textRequired: () => css`
    font-size: 12px;
    opacity: 0.6;
    margin-top: 6px;
    padding: 0 8px;
  `,

  btnClose: css`
    position: absolute;
    right: -1px;
    top: 6px;

    font-size: 24px;
    color: ${theme.colors.orange[200]};
    text-decoration: none;
  `,

  blockCaptcha: (background: string) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 27px;
    margin-right: 10px;

    background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    span {
      font-size: 20px;
      opacity: 0.6;
      font-style: italic;
    }
  `,
};
